/* JS AI Search part 7: the AI Shopper results page (opened by "See all results", /search?...&jsai=1).
   Shows every match of the AI search instead of Shopify's keyword results, keeps an AI Shopper search bar on the
   page so the shopper can carry on, and offers instant narrow-down buttons. If anything fails the normal Shopify
   results (rendered underneath by the theme) are shown again. Loaded in order with the other js-ai-*.js files. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var cfg = root.JSAI;
  var htmlEl = document.documentElement;
  function release() { htmlEl.classList.remove('jsai-takeover'); }
  if (!X.ui || !X.page || !/[?&]jsai=1\b/.test(location.search)) { if (!X.ui) release(); return; }
  var host = document.getElementById('tt-pageContent');
  if (!host) { release(); return; }

  var U = X.ui, P = X.page, copy = U.copy, state = U.state, h = U.h, money = U.money, priceLabel = U.priceLabel,
      imgUrl = U.imgUrl, productUrl = U.productUrl, verifyItems = U.verifyItems, verifyBundles = U.verifyBundles, logSearch = U.logSearch;
  var cleanText = X.cleanText;
  var BATCH = 24;
  var seq = 0;
  var S = { q: '', r: null, maxPence: null, type: null, cheap: false, shown: 0, items: [], tok: 0 };

  var page = h('div', { 'class': 'jsai-page', role: 'region', 'aria-label': 'AI Shopper results' });
  var body = h('div', { 'class': 'jsai-pagebody' });
  host.insertBefore(page, host.firstChild);

  function urlQuery() {
    var m = /[?&]q=([^&]*)/.exec(location.search);
    try { return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; } catch (e) { return ''; }
  }
  function normalUrl(q) { return '/search?type=product&q=' + encodeURIComponent(q); }
  function placeholder() { return innerWidth < 520 ? copy.placeholderShort : copy.placeholder; }

  // ---- the AI Shopper bar that stays on this page
  var input = h('input', { type: 'search', name: 'jsai-q', 'class': 'jsai-pageinput', autocomplete: 'off', placeholder: placeholder(), 'aria-label': placeholder() });
  var go = h('button', { type: 'submit', 'class': 'jsai-pagego', text: 'Ask' });
  var form = h('form', { 'class': 'jsai-bar', role: 'search' }, [input, go]);
  form.addEventListener('submit', function (e) { e.preventDefault(); search(input.value, true); });
  window.addEventListener('resize', function () { input.setAttribute('placeholder', placeholder()); });
  page.appendChild(h('h1', { 'class': 'jsai-pagetitle', text: 'AI Shopper' }));
  page.appendChild(form);
  page.appendChild(body);

  function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }
  function setBody(nodes) { clear(body); nodes.forEach(function (n) { if (n) body.appendChild(n); }); }

  function summaryText(reply, count) {
    var bits = [count + (count === 1 ? ' in-stock product' : ' in-stock products')];
    if (reply.budgetMax !== null) bits.push((reply.budgetMin !== null ? money(reply.budgetMin) + ' to ' : 'up to ') + money(reply.budgetMax));
    else if (reply.budgetMin !== null) bits.push('from ' + money(reply.budgetMin));
    if (S.r.usedAi) bits.push(copy.aiNote);
    return bits.join(' · ');
  }

  // ---- results after the shopper's narrow-down choices (all instant, no AI, no cost)
  function filtered() {
    var items = S.r.reply.items.slice();
    if (S.type) items = items.filter(function (it) { return it.type === S.type; });
    if (S.maxPence !== null) items = items.filter(function (it) { return it.priceMin <= S.maxPence; });
    if (S.cheap) items.sort(function (a, b) { return a.priceMin - b.priceMin; });
    return items;
  }

  function pill(label, pressed, onClick) {
    var b = h('button', { type: 'button', 'class': 'jsai-pill', 'aria-pressed': pressed ? 'true' : 'false', text: label });
    b.addEventListener('click', onClick);
    return b;
  }

  function refineBar() {
    var kids = [];
    [5, 10, 15, 25].forEach(function (n) {
      kids.push(pill('Under ' + money(n * 100), S.maxPence === n * 100, function () { S.maxPence = S.maxPence === n * 100 ? null : n * 100; draw(); }));
    });
    kids.push(pill('Cheapest first', S.cheap, function () { S.cheap = !S.cheap; draw(); }));
    var counts = {}, order = [];
    S.r.reply.items.forEach(function (it) { if (it.type) { if (!counts[it.type]) { counts[it.type] = 0; order.push(it.type); } counts[it.type]++; } });
    order.sort(function (a, b) { return counts[b] - counts[a]; });
    if (order.length > 1) order.slice(0, 6).forEach(function (t) { kids.push(pill(t, S.type === t, function () { S.type = S.type === t ? null : t; draw(); })); });
    return h('div', { 'class': 'jsai-refine', role: 'group', 'aria-label': 'Narrow down' }, kids);
  }

  function card(it) {
    var single = it.variantCount === 1 && it.variants.length === 1 ? it.variants[0] : null;
    var img = it.image ? h('img', { src: imgUrl(it.image, 400), alt: '', loading: 'lazy' }) : h('span', { 'class': 'jsai-noimg' });
    var action;
    if (single) {
      action = h('button', { type: 'button', 'class': 'jsai-btn', text: copy.add });
      action.addEventListener('click', function () { P.addToCart(single.id, action); });
    } else {
      action = h('a', { 'class': 'jsai-btn jsai-btn-alt', href: productUrl(it.handle), text: copy.options });
    }
    return h('li', { 'class': 'jsai-card' }, [
      h('a', { 'class': 'jsai-cardimg', href: productUrl(it.handle), tabindex: '-1', 'aria-hidden': 'true' }, [img]),
      h('a', { 'class': 'jsai-title', href: productUrl(it.handle), text: it.title }),
      h('div', { 'class': 'jsai-meta' }, [h('span', { 'class': 'jsai-price', text: priceLabel(it) }), h('span', { 'class': 'jsai-stock', text: 'In stock' })]),
      action
    ]);
  }

  // ---- the grid: 24 at a time, each batch checked live against the store before it is shown
  function draw() {
    var reply = S.r.reply, items = filtered();
    S.items = items; S.shown = 0;
    var grid = h('ul', { 'class': 'jsai-grid' });
    var more = h('button', { type: 'button', 'class': 'jsai-more', text: '' });
    more.hidden = true;
    var note = h('p', { 'class': 'jsai-fine', text: 'Checking stock and prices…' });
    var summary = h('p', { 'class': 'jsai-summary', 'aria-live': 'polite', text: summaryText(reply, items.length) });
    var nodes = [summary, refineBar()];
    var mine = ++seq;

    function showBatch() {
      var slice = S.items.slice(S.shown, S.shown + BATCH);
      S.shown += slice.length;
      more.disabled = true;
      var budget = { min: reply.budgetMin, max: S.maxPence !== null && (reply.budgetMax === null || S.maxPence < reply.budgetMax) ? S.maxPence : reply.budgetMax };
      verifyItems(slice, budget, slice.length).then(function (o) {
        if (mine !== seq) return;
        o.items.forEach(function (it) { grid.appendChild(card(it)); });
        note.textContent = o.unverified ? copy.stale : '';
        var left = S.items.length - S.shown;
        more.disabled = false;
        more.textContent = 'Show more (' + left + ')';
        more.hidden = left <= 0;
        if (!grid.firstChild && left > 0) showBatch();
      });
    }
    more.addEventListener('click', showBatch);

    if (items.length) { nodes.push(grid); nodes.push(more); nodes.push(note); showBatch(); }
    else if (!(reply.bundles.length || reply.alternatives.length)) nodes.push(emptyState());

    if (!S.extrasDone) {  // combinations and sold-out alternatives are checked once per search
      S.extrasDone = true;
      var bud = { min: reply.budgetMin, max: reply.budgetMax }, tok = S.tok;
      Promise.all([verifyItems(reply.alternatives, bud, 4), verifyBundles(reply.bundles, bud)]).then(function (all) {
        if (tok !== S.tok) return;   // the shopper has searched again meanwhile
        S.extrasNodes = [];
        if (all[1].bundles.length) {
          S.extrasNodes.push(P.section(copy.bundleHead, all[1].bundles.map(function (b, i) {
            return h('li', { 'class': 'jsai-bundle' }, [h('div', { 'class': 'jsai-bundle-head', text: 'Option ' + (i + 1) + ' · ' + copy.total + ' ' + money(b.total) }),
              h('ul', { 'class': 'jsai-list' }, b.items.map(function (it) { return P.productRow(it); }))]);
          })));
        }
        if (all[0].items.length) S.extrasNodes.push(P.section(copy.altHead, all[0].items.map(function (it) { return P.productRow(it); })));
        S.extrasNodes.forEach(function (n) { body.insertBefore(n, body.querySelector('.jsai-pagefoot')); });  // appended before the footer
      });
    } else if (S.extrasNodes) {
      S.extrasNodes.forEach(function (n) { nodes.push(n); });
    }
    nodes.push(pageFoot());
    setBody(nodes);
  }

  function emptyState() {
    var chips = (S.r.engine ? S.r.engine.topTypes.slice(0, 8) : []).map(function (t) {
      var a = h('a', { 'class': 'jsai-chip', href: '/search?type=product&q=' + encodeURIComponent(t) + '&jsai=1', text: t });
      a.addEventListener('click', function (e) { e.preventDefault(); input.value = t; search(t, true); });
      return a;
    });
    return h('section', { 'class': 'jsai-section' }, [h('div', { 'class': 'jsai-head', text: copy.none }), h('div', { 'class': 'jsai-chips' }, chips)]);
  }

  function pageFoot() {
    return h('div', { 'class': 'jsai-foot jsai-pagefoot' }, [
      h('a', { 'class': 'jsai-all', href: normalUrl(S.q), text: 'See the normal search results for this wording' }),
      h('p', { 'class': 'jsai-fine', text: copy.age })
    ]);
  }

  function search(text, push) {
    var q = cleanText(text).slice(0, 300), mine = ++seq;
    input.value = q;
    S.tok = mine; S.q = q; S.r = null; S.maxPence = null; S.type = null; S.cheap = false; S.extrasDone = false; S.extrasNodes = null;
    if (push && root.history && history.pushState) history.pushState(null, '', '/search?type=product&q=' + encodeURIComponent(q) + '&jsai=1');
    if (!q) { setBody([h('p', { 'class': 'jsai-summary', text: 'Tell the AI Shopper what you are after, for example: what can I buy under £15, banana, strawberry.' })]); return; }
    setBody([h('div', { 'class': 'jsai-loading', text: copy.loading })]);
    P.resolve(q, { limit: 300, verify: false }).then(function (r) {
      if (mine !== seq) return;
      if (r.medical) {
        setBody([h('section', { 'class': 'jsai-section' }, [h('div', { 'class': 'jsai-head', text: 'We can’t give health advice' }),
          h('p', { 'class': 'jsai-fine', text: 'Try a product type, brand, size or price instead.' })]), pageFoot()]);
        return;
      }
      S.r = r;
      draw();
      setTimeout(function () { if (S.q === q) logSearch(q, r.reply, r.aiState, true); }, 900);
    }).catch(function () { page.parentNode && page.parentNode.removeChild(page); release(); });  // fall back to the normal results
  }

  window.addEventListener('popstate', function () {
    if (/[?&]jsai=1\b/.test(location.search)) search(urlQuery(), false); else location.reload();
  });

  root.__JSAI_PAGE_READY = true;
  search(urlQuery(), false);
})(window);